import { render, staticRenderFns } from "./PackatsIcon.vue?vue&type=template&id=8594db9a&"
import script from "./PackatsIcon.vue?vue&type=script&lang=js&"
export * from "./PackatsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports